import { Paper, PaperProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

const StyledMenu = styled(Paper)(() => {
  return { margin: '0.25rem auto auto auto' };
});

const NavbarMenuTsoPq = forwardRef<HTMLDivElement, PaperProps>(({ children, ...props }, ref) => {
  return (
    <StyledMenu ref={ref} {...props}>
      {children}
    </StyledMenu>
  );
});

export default NavbarMenuTsoPq;
